// The "Book measure" panel's pure part (S2): which slots to show first. Chronological — the engine
// already sorts — so the list reads like a diary; `near` is a flag the button wears, not a reorder.
export type MeasureSlot = { start: string; end: string; label: string; near: boolean };
export type MeasureBooked = { start: string; end: string; source: string; calendar_state: "held" | "queued"; calendar_note: string | null };
export type MeasureSlotsData = { slots: MeasureSlot[]; timezone: string; booked?: MeasureBooked | null };

const label = (iso: string) => {
  const p = Object.fromEntries(new Intl.DateTimeFormat("en-AU", { timeZone: "Australia/Sydney", weekday: "short", day: "numeric", month: "short", hour: "numeric", minute: "2-digit", hour12: true }).formatToParts(new Date(iso)).map((x) => [x.type, x.value]));
  return `${p.weekday} ${p.day} ${p.month}, ${p.hour}:${p.minute}${String(p.dayPeriod ?? "").toLowerCase().replace(/\./g, "")}`;
};

export function measureSlotView(data: MeasureSlotsData, limit: number) {
  const booked = data.booked ? { ...data.booked, label: label(data.booked.start) } : null;
  return { slots: data.slots.slice(0, limit), hasMore: data.slots.length > limit, booked };
}
